import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";

var _dec, _class;

import React, { Component } from 'react';
import { styled, StyleSheet } from '@rexlabs/styling';
var PasswordToggle = (_dec = styled(StyleSheet({
  pointer: {
    cursor: 'pointer'
  },
  toggle: {
    height: 200,
    width: 200
  }
})), _dec(_class =
/*#__PURE__*/
function (_Component) {
  _inherits(PasswordToggle, _Component);

  function PasswordToggle() {
    _classCallCheck(this, PasswordToggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasswordToggle).apply(this, arguments));
  }

  _createClass(PasswordToggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          s = _this$props.styles,
          showPassword = _this$props.showPassword,
          onClick = _this$props.onClick;
      return React.createElement("span", _extends({
        onClick: onClick
      }, s('toggle')), showPassword ? 'hide' : 'show');
    }
  }]);

  return PasswordToggle;
}(Component)) || _class);
export default PasswordToggle;